<div class="fw-bold bg-white p-3 rounded-5 mb-5 shadow">
    <button class="btn btn-secondary" (click)="location.back()">Back</button>
    <br />
    <div class="row mt-3">
        <div class="mb-3 d-flex gap">
            <h2 class="title-list no-wrap">Sim Search</h2>

            <input type="text" class="form-control input-label" placeholder="ICCID, IMEI or Username..." [(ngModel)]="textToSearch" />
            <button class="btn btn-secondary no-wrap" [disabled]="!textToSearch"
                    (click)="searchSim()">
                <i class="bi bi-search margin-r-05"></i>SIM Search
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <app-table-control [columns]="columns"
                               [data]="sims" [pageSize]="10"
                               (actionClick)="onAction($event)"
                               [actionButtons]="actionButtons"
                               [showActions]="true">
            </app-table-control>
        </div>
    </div>
</div>
